import { render, staticRenderFns } from "./AssessmentInterviewQuestionMultiChoice.vue?vue&type=template&id=6c8aaafe&scoped=true"
import script from "./AssessmentInterviewQuestionMultiChoice.vue?vue&type=script&lang=js"
export * from "./AssessmentInterviewQuestionMultiChoice.vue?vue&type=script&lang=js"
import style0 from "./AssessmentInterviewQuestionMultiChoice.vue?vue&type=style&index=0&id=6c8aaafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8aaafe",
  null
  
)

export default component.exports